import { Component, OnInit } from '@angular/core';
import { Subject, Subscription } from "rxjs";
import { ActivatedRoute } from '@angular/router';
import {
  CurrentVenueHelperService
} from "../../../../share-modul/services/current-venue-helper/current-venue.helper.service";
import { Router } from "@angular/router";
import { DialogService } from 'primeng/dynamicdialog';
import { ConfirmationService, MessageService } from "primeng/api";
import { AddOrEditInventoryComponent } from './add-or-edit-inventory/add-or-edit-inventory.component';
import { TranslateService } from '@ngx-translate/core';
import { InventoryDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/Inventory/inventory-dto';
import { GetInventories$Params } from 'src/api/generated/fn/inventory/get-inventories';
import { RemoveInventory$Params } from 'src/api/generated/fn/inventory/remove-inventory';
import { InventoryService } from 'src/api/generated/services/inventory.service';

@Component({
  selector: 'app-inventory',
  templateUrl: './inventory.component.html',
  styleUrls: ['./inventory.component.scss']
})
export class InventoryComponent implements OnInit {

  venueId: string;
  inventories: Array<InventoryDto> | null | undefined = new Array<InventoryDto>();
  spinner: boolean;

  unsubscribe: Subject<void> = new Subject<void>();
  venueIdUpdateSubscription: Subscription;

  constructor (private currentVenueHelper: CurrentVenueHelperService,
              private router: Router,
              private inventoryService: InventoryService,
              private route: ActivatedRoute,
              private dialogService: DialogService,
              private confirmationService: ConfirmationService,
              private translate: TranslateService,
              private messageService: MessageService) {
      
    }

  ngOnInit(): void {   
    this.route.params.subscribe(params => {
      if (params['venue-id'] != null) {
        this.venueId = params['venue-id'];
        this.currentVenueHelper.updateCurrentVenueIdDropdown(params['venue-id']);
        this.loadInventories();
      }
    })
  }

  loadInventories() {
    this.spinner = true;
    const inventoriesParams: GetInventories$Params = { venueId: this.venueId, isRemoved: false };
    this.inventoryService.getInventories(inventoriesParams).subscribe(response => {
        this.spinner = false;
        this.inventories = response.inventories;
    });
  }
  
  public addNewInventory(){
    const ref = this.dialogService.open(AddOrEditInventoryComponent, {
      data: {
        venueId: this.venueId,
        disableMain: this.inventories?.find(inventory => inventory.isMain) != undefined
      },
      width: '372px',
      showHeader: false,
    });
    ref.onClose.subscribe(result => {
      //CHECK
      if (result) {
        if (result.error) {
          this.messageService.add({ severity:'error', summary: 'Creating inventory failed!', life:3000 });
        } else {
          this.loadInventories();
          this.messageService.add({ severity:'success', summary: 'Inventory was succesfully added!', life:3000 });
        } 
      } 
    });
  }

  public editInventory(inventory: InventoryDto){
    const ref = this.dialogService.open(AddOrEditInventoryComponent, {
      data: {
        inventoryId: inventory.id,
        venueId: this.venueId,
        disableMain: this.inventories?.find(inventory => inventory.isMain == true) != undefined
      },
      width: '372px',
      showHeader: false    
    });
    ref.onClose.subscribe( result => {
      //CHECK
      if (result) {
        if (result.error) {
          this.messageService.add({ severity:'error', summary: 'Updating inventory failed!', life:3000 });
        } else {
          this.loadInventories();
          this.messageService.add({ severity:'success', summary: 'Inventory was succesfully updated!', life:3000 });
        } 
      } 
    });
  }

  public deleteInventory(inventory: InventoryDto){
    this.confirmationService.confirm({
      header: this.translate.instant('INVENTORY.DELETE_CONFIRMATION_TITLE'),
      message: this.translate.instant('INVENTORY.DELETE_CONFIRMATION_TEXT') + inventory.name + "?" + (inventory.isMain ? "</br></br><span class='soc-danger-color'>" + this.translate.instant('INVENTORY.DELETE_MAIN_INVENTORY_INFO') + " </span>" : ""),
      acceptLabel: this.translate.instant('YES'),
      rejectLabel: this.translate.instant('NO'),
      defaultFocus: "reject",
      acceptButtonStyleClass: 'soc-confirmation-dialog dialog-btn destructive-btn',
      rejectButtonStyleClass: 'soc-confirmation-dialog dialog-btn reject-btn',
      accept: () => {
        if(inventory.id){
          const params: RemoveInventory$Params = { inventoryId: inventory.id }
          this.inventoryService.removeInventory(params).subscribe( _ => {
            this.loadInventories();
          });
        }
      }
    });
  }

  openInventory(inventory: InventoryDto){
    this.router.navigate([this.venueId, 'inventory', inventory.id ], { queryParams: { activeIndex: 0 }});
  }

  public ngOnDestroy(): void {
    if (this.venueIdUpdateSubscription) {
      this.venueIdUpdateSubscription.unsubscribe();
    }
  }
}
